const baseURL = 'http://menu.appboutique.click/';

export default baseURL;
